<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderRight :headerText="headerText" :headerTextEmpahasis="headerTextEmpahasis" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :headerTextEmpahasis="headerTextEmpahasis" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <Activation />
    <div class="text-center mt-3">
        <p class="sub-main-text font20 pt-5"> Help us bridge cultural differences and fight biases through our action oriented and responsive social interactions.</p>
    </div>
    <div class="container custome-card n-mr-top">
        <div class="text-center desktop mb-5">
            <p class="main-text pt-5">Donation Information</p>
        </div>
        <div class="text-center mobile ">
            <p class="main-text pt-5">Donation Information</p>
        </div>
        <section class="text-center mb-5">
            <p class="sub-main-text">
                Thanks for helping us achieve our goals at this time </p>
            <div class="m-2">
                <span @click="setAmount(100)" class="m-2 btn btn-outline-secondary">$100</span>
                <span @click="setAmount(200)" class="m-2 btn btn-outline-secondary">$200</span>
                <span @click="setAmount(500)" class="m-2 btn btn-outline-secondary">$500</span>
                <span @click="setAmount(1000)" class="m-2 btn btn-outline-secondary">$1000</span>
            </div>
            <p>-or-</p>
            <b-row align-h="center" class="">
                <b-col cols="12" md="6" class="mt-3 mb-5">
                    <b-form-group class=" mb-4" label-for="address">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon icon="cash"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="number" min="1" v-model="amount" step="0.01" placeholder="Enter an amount of choice"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class=" col-md-12 mb-3" label-for="input-1">
                        <button @click="makePayment" type="submit" class="btn btn-warning">
                            <b-icon icon="shield-lock"></b-icon>
                            {{btnText}}
                        </button>
                    </b-form-group>
                </b-col>
            </b-row>

        </section>

    </div>

    <Footer />

</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderRight from "@/components/BlackHeaderRight.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";
import axios from "axios";
import {
    getBaseUrl
} from "../../utils/common";
const base_url = getBaseUrl();

export default {
    name: "about-us",
    data: function () {
        return {
            headerText: "Donate",
            headerTextEmpahasis: "to raise funds",
            subText: "Help us achieve our goals",
            fadedText: "Donate",
            amount: '',
            btnText: 'Donate',
            currency: 'USD',
            charge: {}
        }
    },
    components: {
        Header,
        BlackHeaderRight,
        BlackHeaderMobile,
        BodyLinks,
        Activation,
        Footer,

    },
    methods: {
        setAmount(amount) {
            this.amount = amount
        },
        async makePayment() {
            if (this.amount == 0) {
                alert("Please enter an amount")
            } else {
                try {
                    this.charge = {
                        amount: this.amount,
                        currency: this.currency
                    }
                    const response = await axios({
                        url: `${base_url}/api/v2/donate/intent`,
                        data: this.charge,
                        method: "POST",
                    })
                    this.$router.push({
                        name: 'donation-pay',
                        params: {
                            secret: response.data,
                            charge: this.charge
                        }
                    })
                } catch (error) {
                    this.payBtn = 'Donate';
                    this.$root.$refs.A.makeToast('danger', 'An error occured, please try again later')
                }
            }

        }
    }
}
</script>

<style scoped>
.mb-5 {
    margin-bottom: 5rem !important
}
.n-mr-top{
    margin-top: -3.4em;
}
.culture-section {
    height: 660px;
    margin-top: 150px;
    background-image: url('../assets/images/cultural-image.png');
    background-repeat: no-repeat;
    background-position: right;
}

.culture-sec img {
    height: 43vh
}

.form-control {
    border-radius: 0 8px 8px 0 !important;
    height: calc(2em + 0.75rem + 15px) !important;
}

.offset-black {
    height: 528px;
    width: 47%;
    background: #000;
    color: #fff;
    margin-top: -80px;
    position: absolute;
    padding: 80px
}

.cul-black-section {
    background: #000;
    width: 100%;
    padding: 1.5rem;
    color: #fff;
}

.cul-black-section p:first-child {
    color: #F7B131;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 24px;
    letter-spacing: -0.25px;
}

.offset-black p {
    font-size: 18px;
    line-height: 32px;
    text-justify: auto;
    letter-spacing: 0.25px;

}

.offset-black p:first-child {
    font-weight: 600;
    font-size: 26px;
    letter-spacing: -0.25px;
    text-transform: uppercase;
    color: #F7B131;
}

.btn-warning {
    padding: 10px 30px;
}

@media screen and (min-width: 1400px) {
    .culture-section {
        background-repeat: no-repeat;
        background-size: cover;
    }
}
</style>
